/** Phase 2A test ids — appended in index.js */
export const TIDS_P2 = {
    // skills
    skillsHub: "skills-hub",
    skillCard: (slug) => `skill-card-${slug}`,
    skillDetail: "skill-detail",
    skillWorksheetInput: (qid) => `skill-worksheet-${qid}`,
    skillReflection: "skill-reflection",
    skillRating: "skill-rating",
    skillPracticeSubmit: "skill-practice-submit",
    skillPracticeSuccess: "skill-practice-success",

    // habits
    habitsPage: "habits-page",
    habitToggle: (slug) => `habit-toggle-${slug}`,

    // gratitude
    gratitudePage: "gratitude-page",
    gratitudeItem: (i) => `gratitude-item-${i}`,
    gratitudeSubmit: "gratitude-submit",
    gratitudeSaved: "gratitude-saved",

    // goals
    goalsPage: "goals-page",
    goalNewBtn: "goal-new-btn",
    goalTitleInput: "goal-title-input",
    goalCategoryInput: "goal-category-input",
    goalSubmitNew: "goal-submit-new",
    goalCard: (id) => `goal-card-${id}`,
    goalProgressBtn: (id) => `goal-progress-btn-${id}`,
    goalProgressNote: "goal-progress-note",
    goalProgressPct: "goal-progress-pct",
    goalProgressSubmit: "goal-progress-submit",
    goalComplete: (id) => `goal-complete-${id}`,

    // insights
    insightsPage: "insights-page",
    insightsMoodChart: "insights-mood-chart",
    insightsDistribution: "insights-distribution",

    // accountability
    accountabilityPage: "accountability-page",
    accountabilityNewBtn: "accountability-new-btn",
    accountabilityType: "accountability-type",
    accountabilityRecipient: "accountability-recipient",
    accountabilityStatement: "accountability-statement",
    accountabilitySubmit: "accountability-submit",
    accountabilityFeedback: "accountability-feedback",
    accountabilityScore: "accountability-score",
};
